import { LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Time given to the browser to pick up the download, and to iOS to put up the
// "Add to Apple Wallet" sheet, before the page moves on.
const RETURN_DELAY_MS = 2000;

// Drives the page a customer lands on from a Wallet Pass QR code or SMS link. A download
// response can't also move the tab, so the download and the return trip are split here;
// without the return trip the customer is left on a blank tab once the download finishes.
@customElement('kin-wallet-pass-download')
export class WalletPassDownloadComponent extends LitElement {
  @property({ type: String, attribute: 'pass-url' })
  passUrl: string = '';

  @property({ type: String, attribute: 'return-url' })
  returnUrl: string = '';

  private timer?: number;

  firstUpdated() {
    this.startDownload();
    this.timer = window.setTimeout(() => this.returnToPortal(), RETURN_DELAY_MS);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearTimeout(this.timer);
  }

  // The .pkpass is served as an attachment, so the browser saves it and leaves this page up.
  startDownload() {
    window.location.href = this.passUrl;
  }

  // replace() keeps this page out of history, so Back doesn't re-trigger the download.
  returnToPortal() {
    window.location.replace(this.returnUrl);
  }
}
